// ===================================================================
// Betting Configuration
// ===================================================================
export const DEFAULT_OPTIONS = ["yes", "no"]
export const DEFAULT_AMOUNT = "0.1"
export const MAX_USDC_AMOUNT = 10 // Maximum allowed USDC transaction amount
